module.exports = __webpack_public_path__ + "img/dingwei.4c86acd5.png";